/*
 * Copyright 2016 Lutrons Ltd. All Rights Reserved.
 *
 */

import Authentication from '../authentication/awsAuthentication';
import API from './awsApi';


class ProductAPIClass {

   getAllProducts(handler) {
        Authentication.getSession()
        .then(Authentication.getAuthorisation)
        .then((token) => {
            let dataService = API.newClient();

            let params = {"Authorization": token};
            let body = '';
            let additionalParams = {headers: '',queryParams: {}};
            dataService.defaults.headers.common['Authorization'] = token;
            API.handle(dataService.get('/api/v1/product', params), handler);
        })
        .catch((e) => handler.failure(e));
    }

    getProduct(productId,handler) {
        Authentication.getSession()
        .then(Authentication.getAuthorisation)
        .then((token) => {
            let dataService = API.newClient();
            let params = {'productId' : productId, "Authorization": token};
            dataService.defaults.headers.common['Authorization'] = token;
            API.handle(dataService.get('/api/v1/product/' + productId, params), handler);
        })
        .catch((e) => handler.failure(e));
    }

    saveProduct(product,handler) {
        Authentication.getSession()
        .then(Authentication.getAuthorisation)
        .then((token) => {
            let dataService = API.newClient();
            let params = {"Authorization": token};
            API.handle(dataService.post('/api/v1/product', product), handler);
        })
        .catch((e) => handler.failure(e));
    }

    deleteProduct(productId,handler) {
        Authentication.getSession()
            .then(Authentication.getAuthorisation)
            .then((token) => {
                let dataService = API.newClient();
                let params = {"Authorization": token};
                API.handle(dataService.delete(`/api/v1/product?productId=${productId}`, {}), handler);
            })
            .catch((e) => handler.failure(e));
    }

}

const ProductAPI = new ProductAPIClass();
export default ProductAPI;




// WEBPACK FOOTER //
// ./src/app/api/awsProductAPI.js